import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {logout} from '@iw-shared/store/actions/authentication.action';
import {AppState} from '@iw-shared/store/state/app.state';
import {takeUntil} from 'rxjs/operators';
import {visibilities} from '@iw-shared/store/actions/global.actions';
import {Window} from '@iw-shared/window-manager/interfaces/window.model';
import {UserState} from '@iw-shared/store/state/user.state';
import {EnvironmentService} from "@iw-shared/core/services/environment.service";
import {faUser} from "@fortawesome/free-regular-svg-icons";
import {faSignOut, faBars} from "@fortawesome/free-solid-svg-icons";
import {GlobalState} from "@iw-shared/store/state/global.state";

@Component({
  selector: 'iw-shared-layout-container-logged-in',
  templateUrl: './layout-container-logged-in.component.html',
  styleUrls: ['./layout-container-logged-in.component.scss']
})
export class LayoutContainerLoggedInComponent implements OnInit, OnDestroy {


  private ngUnsubscribe: Subject<void> = new Subject<void>();
  logoutLoading = false;
  isAuthenticated$?: Observable<string | null>;
  isTaskbar$?: Observable<Window[] | null>;
  user$?: Observable<UserState>;
  global$?: Observable<GlobalState>;
  shopUrl?: string | undefined;

  isMenu: boolean = true;
  contentClass?: string;


  constructor(
    private store: Store<AppState>,
    private environmentService: EnvironmentService) {
    this.isAuthenticated$ = this.store.select(state => state.storage.userId);
    this.isTaskbar$ = this.store.select(state => state.windows.items);
    this.user$ = this.store.select(state => state.user);
    this.global$ = this.store.select(state => state.global);

    this.store.select(state => state.global.visibilities.menu)
      .pipe(
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(
        menu => {

          if (menu === true) {
            this.isMenu = menu;
            this.contentClass = 'menu-visible';
          } else if (menu === false) {
            this.isMenu = menu;
            this.contentClass = 'menu-invisible';
          }
        }
      );
  }

  ngOnInit(): void {

  }

  isDicom(): boolean{
    if(window.location.host == 'login.gesoft.de'){
      return true;
    }
    return false;
  }

  isProduction(): boolean {
    return this.environmentService.environment.production;
  }

  toggleMenu() {
    this.store.dispatch(visibilities({property: 'menu', value: !this.isMenu}))
  }

  logout() {
    this.store.dispatch(logout());
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  protected readonly faUser = faUser;
  protected readonly faBars = faBars;
  protected readonly faSignOut = faSignOut;
}
